<template>
  <div class="mb-5" style="padding: 20px" :class="{ previewPrint: preview }">
    <div class="row mb-3">
      <div class="col-4">
        <img
          v-if="true"
          :style="{
            marginLeft: `${logoMarginLeft}px`,
            width: `${logoWidth}px`,
            height: `150px`
          }"
          :src="this.companyClinicLogo"
        />
      </div>
      <div class="col-8 clinic-info">
        <div class="row">
          <div class="col-12 row">
            <div class="col-4">{{trans('makuang.VisitBranch') }}</div>
            <div class="col">:&nbsp; {{ invoiceBranchName || '-' }}</div>
          </div>
          <div class="col-12 row">
            <div class="col-4">{{trans('makuang.BranchAddress') }}</div>
            <div class="col">:&nbsp; {{ invoiceAddress || '-' }}</div>
          </div>
          <div class="col-12 row">
            <div class="col-4">{{trans('makuang.Tel') }}</div>
            <div class="col">:&nbsp; {{ general.telephone || '-' }}</div>
          </div>
          <div class="col-12 row">
            <div class="col-4">{{trans('makuang.Fax') }}</div>
            <div class="col">:&nbsp; {{ general.fax || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 0 20px" >

    <div class="row mb-3">
      <div class="col-12">
        <h3 class="mb-3 text-center text-uppercase">
          <u>
            <!-- <span v-if="withTaxes">{{trans('general.tax') }}</span> -->
            {{trans('general.receipt') }}
          </u>
        </h3>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="col-12 row" v-if="printConfig.patientName">
          <div class="col-3 text-uppercase">{{trans('general.patientName') }}</div>
          <div class="col">: {{ selectedPatient.name || '-' }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.patientLocalName">
          <div class="col-3 text-uppercase">{{trans('general.patientLocalName') }}</div>
          <div class="col">: {{ selectedPatient.localName || '-' }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.patientPhoneNo">
          <div class="col-3 text-uppercase">{{trans('general.tel') }}</div>
          <div class="col text-nowrap">: {{ patientPhoneNo }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.nric">
          <div class="col-3 text-uppercase">{{trans('makuang.PatientIC') }}</div>
          <div class="col">: {{ selectedPatient.nric || '-' }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.patientAdd">
          <div class="col-3 text-uppercase">{{trans('makuang.Address') }}</div>
          <div class="col"> : {{splitAddress}} </div>
        </div>
        <div class="col-12 row" v-if="printConfig.patientAdd">
          <div class="col-3 text-uppercase">{{trans('makuang.PostalCode') }}</div>
          <div class="col-6">: {{ selectedPatient.postal || '-' }}</div>
        </div>
        <br/>
        <div class="col-12 row">
          <div class="col-3 text-uppercase">{{trans('general.invoiceNumber') }}</div>
          <div class="col">:&nbsp; {{ print.invoiceNo }}</div>
        </div>
        <div class="col-12 row">
          <div class="col-3 text-uppercase">{{trans('general.date') }}</div>
          <div class="col">:&nbsp; {{ print.date
              | formatVDDate({
                sourceFormat: 'X',
                lang: 'en',
                format: 'DD MMM YYYY',
              }) }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.invoiceDateBE">
          <div class="col-3 text-uppercase">{{trans('setting.invoiceDateBE') }}</div>
          <div class="col">:&nbsp;
          {{
            print.date
              | formatVDDate({
                sourceFormat: 'X',
                lang: 'th',
                format: 'DD MMM YYYY',
              })
          }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.paymentTime">
          <div class="col-3 text-uppercase">{{trans('general.paymentTime') }}</div>
          <div class="col">:&nbsp; {{ paymentTime }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.regNumber">
          <div class="col-3 text-uppercase" v-if="printConfig.showGSTLabel">{{trans('setting.gstRegNoLabel') }}</div>
          <div class="col-3 text-uppercase" v-else>{{trans('setting.gstRegNo') }}</div>
          <div class="col">:&nbsp; {{ general.gstRegNo }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.docName">
          <div class="col-3 text-uppercase" v-if="featureFlags.doctorToConsultant">{{trans('general.attendingDoctortoConsult') }}</div>
          <div class="col-3 text-uppercase" v-else>{{trans('general.attendingPhysician') }}</div>
          <div class="col">:&nbsp; {{ provider.name }}</div>
        </div>
        <div class="col-12 row">
          <div class="col-3 text-uppercase">{{trans('tcm.consultationPrescription.clinicAsst') }}</div>
          <div class="col">:&nbsp; {{ print.queue && print.queue.addedBy && print.queue.addedBy.name || '' }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.docQual">
          <div class="col-3 text-uppercase">{{trans('general.qualifications') }}</div>
          <div class="col">:&nbsp; {{ provider.qualifications }}</div>
        </div>
        <div class="col-12 row" v-if="printConfig.therapistName">
          <div class="col-3 text-uppercase">{{trans('general.attendingTherapist') }}</div>
          <div class="col">:&nbsp; {{ print.therapist && print.therapist.name }}</div>
        </div>
      </div>
    </div>

    <!-- table header -->
    <div class="row weight-600 bd-top bd-bottom">
      <div class="col-4">Service</div>
      <div class="col-4">
        {{trans('general.description') }}
      </div>
      <div class="col-2 text-center">
        {{trans('general.qty') }}
      </div>

      <div class="col-2 text-right">{{trans('makuang.Amount') }}</div>
    </div>

    <!-- table body for categorized invoice -->
    <div v-if="isCategorized">
      <div v-for="(category, idx) in categorized" :key="category.key">
        <div class="mt-1 row">
          <div class="col-4" style="padding-right: 0px">
            {{ idx }}
          </div>
          <div class="col-4 weight-600 mb-1" style="padding-right: 0px"></div>
          <div class="col-2 weight-600 mb-1" style="padding-right: 0px"></div>
          <div class="col-2 weight-600 mb-1 text-right">
            {{ getTotalPricePerInvoiceCategory(category) }}
          </div>
        </div>
      </div>
    </div>

    <!-- table body for uncategorized invoice -->
    <div v-else>
      <div v-for="(category, idx) in unCategorized" :key="category.key">
        <div class="row">
          <div class="mt-2">
            <div class="col-12 weight-600" style="padding-right: 0px">
              {{ idx }}
            </div>
          </div>
        </div>

        <div v-for="(item, id) in category" :key="item.key" class="mt-1 row">
          <div class="col-4" style="padding-right: 0px"></div>
          <div class="col-4" style="padding-right: 0px">
            {{ id }}
          </div>
          <div class="col-2 text-center" style="padding-right: 0px">
            {{ getTotalQuantity(item) }}
          </div>
          <div class="col-2 text-right">
            {{ getTotalPricePerInvoiceCategory(item) }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="redeem && redeem.point > 0">
      <div class="row weight-600">
        <div class="col-10 text-left">
          {{trans('membership.redeemOfPoint') }} {{ region.currency }}
        </div>
        <div class="col-2 text-right">
          -{{
            redeem.amount
              | to2Decimal(region.decimal)
              | thousandSeparator(region.thousandSeparator)
          }}
        </div>
      </div>
    </div>

    <div class="row mt-1 bd-top"></div>

    <!-- total discount  -->
    <div class="row">
      <div class="col-10 text-right">
        {{trans('general.totalDiscount') }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          totalDiscount
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <!-- Before Tax -->
    <div v-if="withTaxes" class="row marginRight">
      <div class="col-10 text-right">
        {{ beforeTaxLabel }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          beforeTax
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <!-- GST Tax -->
    <div v-if="withTaxes" class="row marginRight">
      <div class="col-10 text-right">
        {{
          (print.taxName || invoiceConfig.taxName) +
          ' ' +
          invoiceConfig.taxPercentageAmount +
          ' %'
        }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          print.totalTax
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <!-- Rounding -->
    <div class="row marginRight">
      <div class="col-3"></div>
      <div class="col-7 text-right">
        {{trans('general.rounding') }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          print.roundingAdjustment
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <div v-if="processFees" class="row">
      <div class="col-4"></div>
      <div class="col-3"></div>
      <div class="col-3 bd-top text-right">
        {{trans('paymentMode.processValue') }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 bd-top text-right">
        <div v-if="processFees">
          {{
            processFees
              | toVirtualCurrency(
                virtualCurrencyConfig.exchangeRate,
                convertToVirtualCurrency
              )
              | to2Decimal(region.decimal)
              | thousandSeparator(region.thousandSeparator)
          }}
        </div>
      </div>
    </div>

    <!-- total amount -->
    <div class="row weight-600">
      <div class="col-4"></div>
      <div class="col-3"></div>
      <div class="col-3 bd-top bd-bottom text-right">
        {{trans('makuang.Total') }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 bd-top bd-bottom text-right">
        {{
          (total)
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <!-- total_virtual_currency_redeemed -->
    <!--
    <div class="row marginRight mt-4">
      <div class="col-10 text-right">
        {{ trans('membership.redeemed') }}
        ({{ virtualCurrencyConfig.name }})
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          print.totalVirtualCurrencyRedeemed || 0
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>
     -->

    <!-- total paid -->
    <div class="row marginRight">
      <div class="col-10 text-right">
        {{trans('makuang.TotalPaid') }}
        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          totalPaidAmount
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <!-- Change -->
    <!--
    <div class="row marginRight">
      <div class="col-10 text-right">
        {{trans('makuang.Change') }}

        {{
          region.currency
            | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency)
        }}
      </div>
      <div class="col-2 text-right">
        {{
          totalChange
            | toVirtualCurrency(
              virtualCurrencyConfig.exchangeRate,
              convertToVirtualCurrency
            )
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>
    -->

    <!-- payment details -->
    <!--
    <div class="row mt-4">
      <div class="col-3 text-right" style="font-weight: bolder">
        {{trans('makuang.PaymentDetails') }} :
      </div>
    </div>
    <div
      class="row mt-4"
      v-for="payment in patientPayments"
      :key="payment.paymentId"
    >
      <div class="col-2 text-right">
        {{ payment.label }}
        {{ region.currency }}
      </div>
      <div class="col-2">
        {{
          payment.amount
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>

    <div
      class="row mt-4"
      v-for="payment in creditPayments"
      :key="payment.paymentId"
    >
      <div class="col-10 text-right">
        {{ payment.mode }} -- {{ payment.paymentType }} : {{ region.currency }}
      </div>
      <div class="col-2 text-right">
        {{
          payment.amount
            | to2Decimal(region.decimal)
            | thousandSeparator(region.thousandSeparator)
        }}
      </div>
    </div>
    -->

    <div v-if="!!printConfig.ostBalance" class="row mt-1 weight-600">
      <div class="col-10 text-right">
        {{ $t('general.outstandingBalance') }} {{ region.currency | shouldHideCurrencyIfConvertingToVC(convertToVirtualCurrency) }}
      </div>
      <div class="col-2 text-right">
        {{ print.ostBalance |
          toVirtualCurrency(virtualCurrencyConfig.exchangeRate, convertToVirtualCurrency) |
          to2Decimal(region.decimal) |
          thousandSeparator(region.thousandSeparator) }}
      </div>
    </div>

    <div class="row mt-1 weight-600" v-if="virtualCurrencyConfig.enable && printConfig.virtualCurrency">
      <div class="col-10 text-right">
        {{ virtualCurrencyConfig.name }} {{ $t('general.balance') }}
        <span>({{ $t('general.asOf') }} {{ now | formatVDDate({ lang: $i18n.locale, format: 'DD MMM YYYY'}) }})</span>
      </div>
      <div class="col-2 text-right">
        {{print.totalVCBalance || 0}} {{virtualCurrencyConfig.currencyCode}}
      </div>
    </div>
    <!--
    <div class="row mt-1 weight-600" v-if="shouldShowMembershipPtBalance && !!membershipConfig.enableModule && !!printConfig.membership">
      <div class="col-10 text-right">
        {{ $t('membership.RPBL') }}
        <span>({{ $t('general.asOf') }} {{ now | formatVDDate({ lang: $i18n.locale, format: 'DD MMM YYYY'}) }})</span>
      </div>
      <div class="col-2 text-right">
        {{ print.totalRedeemablePoints }}
        <span v-if="featureFlags.niks">{{ $t('general.nik$') }}</span>
        <span v-else>{{ $t('general.points') }}</span>
      </div>
    </div>
    <template v-if="withDiagnosis || printConfig.diagnosis">
      <div class="row weight-600">
        <div class="col-12">{{trans('general.diagnosis') }}:</div>
      </div>
      <div v-for="(item, index) in print.diagnosis" :key="index">
        <div v-if="multipleICD10Enabled" class="row">
          <div class="col-3">
            {{
              index === 0
                ? 'Primary Diagnosis'
                : index === 1
                ? 'Secondary Diagnosis'
                : 'Additional Diagnosis'
            }}
          </div>
          <div class="col-9">
            <p v-for="icd in item" :key="icd.uuid">
              <i>{{ icd && icd.text }}</i>
            </p>
          </div>
        </div>
        <div v-else>
          <p v-for="icd in item" :key="icd.uuid">
            <i>{{ icd && icd.text }}</i>
          </p>
        </div>
        <hr v-if="multipleICD10Enabled" />
      </div>
    </template>
    -->
    <br />
    <template v-if="printConfig.notes">
      <div class="weight-600">{{trans('general.notes') }}:</div>
      <p style="white-space: pre-line">{{ print.notes }}</p>
    </template>
    <template v-if="corpPayables.length">
      <br />
      <div class="row weight-600">
        <div class="col-12">{{trans('general.amountDueFrom') }}:</div>
      </div>

      <div class="row weight-600 bd-top bd-bottom">
        <div class="col-6">{{trans('general.others') }}</div>
        <div class="col-6">{{trans('general.amount') }}</div>
      </div>

      <div class="row" v-for="payable in corpPayables" :key="payable.paymentId">
        <div class="col-6">{{ payable.label }}</div>
        <div class="col-6">
          {{ region.currency
          }}{{
            payable.amount
              | to2Decimal(region.decimal)
              | thousandSeparator(region.thousandSeparator)
          }}
        </div>
      </div>
    </template>

    <template v-if="corpSettled.length">
      <br />
      <div class="row weight-600">
        <div class="col-12">{{trans('general.amountSettledFrom') }}:</div>
      </div>

      <div class="row weight-600 bd-top bd-bottom">
        <div class="col-6">{{trans('general.others') }}</div>
        <div class="col-6">{{trans('general.amount') }}</div>
      </div>

      <div class="row" v-for="payable in corpSettled" :key="payable.paymentId">
        <div class="col-6">{{ payable.label }}</div>
        <div class="col-6">
          {{ region.currency
          }}{{
            payable.amount
              | to2Decimal(region.decimal)
              | thousandSeparator(region.thousandSeparator)
          }}
        </div>
      </div>
    </template>
    <div class="row" v-if="isCustomNote">
      <div class="col-7"></div>
      <div class="col-5 text-left" style="white-space: pre-line; color: red">
        注意事項：<br />定型化契約<br />1.
        此療程為優惠方案如因故無法使用，除非有身體傷害之狀況，否則不得要求退費，已使用之課程需以原售價扣除。因特殊因素，得允許將已付金頟轉換其他療程。依現行法令規定意退費時，將扣除已接受服務之費用、已提領並拆封之附屬商品金額、終止契約手續費（剩餘金額之百分之10）後退子消費者本人（依現行法令公告規定辦理）已使用部分療程/保養，須以單堂原價計算之。<br />2.手術訂金於術前5天，個人因素而無法手術時得轉换其他療程產品。<br />於手術當天因個人因素取消手術時，訂金不退還也不可轉換其他療程及產品。
      </div>
    </div>
    <br />
    <div class="row mb-3">
      <div class="col-7 weight-600">
        <template v-if="printConfig.clinicHospital">
          {{trans('setting.footerClinicHospital') }} :
        </template>
      </div>
      <div class="col-5 weight-600">
        <template v-if="printConfig.patientSignature">
          {{trans('setting.footerPatientSignature') }} :
        </template>
      </div>
    </div>
    <p v-if="printConfig.footer" style="white-space: pre-line">
      {{ printConfig.footerContent }}
    </p>
    </div>
  </div>
</template>
<script>
import currency from 'currency.js';
import dateFormatter from '@/components/mixins/dateformatter';
import moneyFormatter from '@/components/mixins/money';
import invoiceMethodsMixin from '@/components/mixins/invoice';
import { mapGetters } from 'vuex';
import invoiceService from '@/services/invoice.service';
import _ from 'lodash';

export default {
  name: 'TaxInvoiceComponent',
  mixins: [dateFormatter, moneyFormatter, invoiceMethodsMixin],
  props: {
    selectedPatient: {
      type: Object,
      default: () => ({ corpInsurance: [] }),
    },
    print: {
      type: Object,
      default: () => ({}),
    },
    general: {
      type: Object,
      default: () => ({}),
    },
    virtualCurrencyConfig: {
      type: Object,
      default: () => ({}),
    },
    membershipConfig: {
      type: Object,
      default: () => ({}),
    },
    convertToVirtualCurrency: {
      type: Boolean,
      default: false,
    },
    invoiceConfig: {
      type: Object,
    },
    printConfig: [Array, Object],
    preview: {
      type: Boolean,
      default: false,
    },
    includeGST: [Boolean, Object],
    roundOff: [String, Object],
    isCategorized: {
      type: Boolean,
    },
    redeem: {
      type: Object,
      default: () => ({}),
    },
    processFees: { type: Number, default: 0 },
    multipleICD10Enabled: { type: Boolean, default: false },
    inventoryConfig: {
      type: Object,
      default: () => ({
        usePredefinedCategories: false,
      }),
    },
  },
  data() {
    return {
      now: new Date(),
      sortedInventoryByType: {
        Consultation: [],
        Medicine: [],
        Prescription: [],
        Therapy: [],
        Product: [],
        Package: [],
        Laboratory: [],
        Expendables: [],
        Wyn: [],
      },
      // Because the key of the sortedInventoryByType object above is directly displayed on the page, and not translate,
      // so add this categorizedNameMapTranslateId variable to map the key of the sortedInventoryByType -> translateId,
      // if you add another key in sortedInventoryByType, please add the translateId in categorizedNameMapTranslateId
      categorizedNameMapTranslateId: {
        'Professional Fees Consult':
          'setting.inventoryType.professionalFeesConsult',
        'Professional Fees Procedures':
          'setting.inventoryType.professionalFeesProcedures',
        Facilities: 'setting.inventoryType.facilities',
        Teleconsult: 'setting.inventoryType.teleconsult',
        Consultation: 'setting.inventoryType.consultation',
        Laboratory: 'setting.inventoryType.laboratory',
        Radiology: 'setting.inventoryType.radiology',
        Investigation: 'setting.inventoryType.investigation',
        Medicine: 'setting.inventoryType.medicine',
        Wyn: 'setting.inventoryType.wyn',
        Compounded: 'setting.inventoryType.compounded',
        Product: 'setting.inventoryType.product',
        Vaccination: 'setting.inventoryType.vaccination',
        Injection: 'setting.inventoryType.injection',
        Procedure: 'setting.inventoryType.procedure',
        'Nursing Procedure': 'setting.inventoryType.nursingProcedure',
        Consumables: 'setting.inventoryType.consumables',
        Package: 'setting.inventoryType.package',
        Referral: 'setting.inventoryType.referral',
        Credit: 'setting.inventoryType.credit',
        'Virtual Currency': 'setting.inventoryType.virtualCurrency',
        Misc: 'setting.inventoryType.misc',
        'Order Set': 'setting.inventoryType.orderSet',
      },
    };
  },
  methods: {
    // makuang require receipt to be in english only
    trans(text) {
      return this.$t(text, 'en');
    },
    getTotalPricePerInvoiceCategory(items) {
      const total = items.reduce((a, ite) => {
        if (!!ite.appliedDiscountFromPricingScheme && ['Consultation'].includes(ite.inventory)) {
          return currency(a + ite.afterDiscountPrice).value;
        }
        if (ite.category === 'Medicine Powder' && ite.givenId !== 'MEDICINEPOWDER') {
          return a;
        }
        return a + currency(Number(ite.qty) * Number(ite.price)).value;
      }, 0);
      return total.toFixed(2);
    },
    getTotalQuantity(items) {
      return +(items.reduce((a, ite) => {
        if (ite.givenId === 'MEDICINEPOWDER') {
          return a;
        }
        // eslint-disable-next-line no-return-assign
        return a += Number(ite.qty);
      }, 0));
    },
    async sendEmailSMS() {
      const email = localStorage.getItem('sendEmail');
      const sms = localStorage.getItem('sendSMS');
      const idFrom = this.print.id;
      let typeFrom = null;
      if (email === idFrom) {
        typeFrom = 'email';
        localStorage.removeItem('sendEmail');
      } else if (sms === idFrom) {
        typeFrom = 'sms';
        localStorage.removeItem('sendSMS');
      } else return;
      let htmlFile = document.documentElement.outerHTML;
      // Below is a fix for email not formatted well on production because production uses external css
      htmlFile = htmlFile.replace(
        /href="\/css\//g,
        `href="${window.location.origin}/css/`
      );
      const payload = {
        id: idFrom,
        html: htmlFile,
        type: typeFrom,
      };
      invoiceService.sendReportLink(payload).then((resp) => {
        if (resp.data.result === 'ok') {
          if (typeFrom.toLowerCase() === 'email') {
            // eslint-disable-next-line no-alert
            window.alert(
              'Email is being sent. Please wait for serveral minutes and then check the email.'
            );
          } else {
            // eslint-disable-next-line no-alert
            window.alert('SMS has been sent.');
          }
          // eslint-disable-next-line no-alert
        } else window.alert('Email/SMS failed to send');
      });
    },
  },
  computed: {
    // Makuang ignore pricing schema discount on the receipt
    totalDiscount() {
      const discount = this.print.items.reduce((acc, item) => {
        if (!!item.appliedDiscountFromPricingScheme && ['Consultation'].includes(item.inventory)) {
          return acc;
        }
        return acc + parseFloat(item.discountAmount);
      }, 0);
      return discount;
    },
    isCustomNote() {
      return ['eunicepoint'].includes(localStorage.getItem('orgCode'));
    },
    companyClinicLogo() {
      return this.general.logoURL;
    },
    companyClinicName() {
      return this.general.clinicName;
    },
    companyClinicLocalName() {
      return this.general.clinicLocalName || '';
    },
    promoCode() {
      if (!this.print.promotions) return;
      return this.print.promotions.map((p) => p.promoCode)[0];
    },
    beforeTaxLabel() {
      return this.printConfig.showGSTLabel
        ? this.trans('general.beforeGST')
        : this.trans('general.beforeTax');
    },
    ...mapGetters('config', ['featureFlags']),
    invoiceAddress() {
      return this.general.address;
    },
    invoiceLocalAddress() {
      return this.general.clinicLocalAddress || '';
    },
    invoiceBranchName() {
      const location = this.clinics.find(
        (clinicLocation) => clinicLocation._id === this.print.clinic
      );
      return location ? location.name : '';
    },
    withTaxes() {
      return this.isInvoiceWithGST(this.print, { includeGST: this.includeGST });
    },
    withDiagnosis() {
      if (this.$route && this.$route.query) {
        return this.$route.query.diagnosis === 'true';
      }
      return this.printConfig && this.printConfig.diagnosis;
    },
    splitAddress() {
      return this.selectedPatient.address;
    },
    splitLocalAddress() {
      const localAddress =
        this.selectedPatient.localAddress &&
        this.selectedPatient.localAddress.split(',');
      if (this.selectedPatient.unit) {
        localAddress.splice(-1, 0, this.selectedPatient.unit);
      }

      return localAddress;
    },
    patientPhoneNo() {
      return this.selectedPatient.mobile || this.selectedPatient.telephone || '-';
    },
    categorized() {
      // convert data to object with inventory type as key
      // example: { Medicine: [{...}, {...}], Procedure: [{...}, {...}] }
      const print = this.print.items.reduce((result, a) => {
        const r = result;
        r[a.inventory] = r[a.inventory] || [];
        r[a.inventory].push(a);
        return r;
      }, Object.create(null));

      // add dispense items into the default sorted inventory by type
      const sortedInvType = Object.assign({}, this.sortedInventoryByType);
      const dispensedInvTypes = Object.keys(print);
      for (let i = 0; i < dispensedInvTypes.length; i += 1) {
        sortedInvType[dispensedInvTypes[i]] = print[dispensedInvTypes[i]];
      }

      // remove empty array of inventory type
      const sortedInvTypeKeys = Object.keys(sortedInvType);
      for (let j = 0; j < sortedInvTypeKeys.length; j += 1) {
        if (sortedInvType[sortedInvTypeKeys[j]].length < 1) {
          delete sortedInvType[sortedInvTypeKeys[j]];
        }
      }

      return sortedInvType;
    },

    totalMedicinePrice() {
      const dosageMultiplier =
        (this.print.instructions.timesPerDay || 2) *
        (this.print.instructions.noOfDays || 3);
      return this.categorized.Medicine.reduce((accum, med) => {
        const weight = med.qty / dosageMultiplier;
        return accum + parseFloat(med.price) * weight;
      }, 0);
    },
    totalMedicineAfterDiscountPrice() {
      return this.categorized.Medicine.reduce(
        (accum, med) => accum + parseFloat(med.afterTaxPrice),
        0
      );
    },
    logoMarginLeft() {
      if (localStorage.getItem('printSetup')) {
        return JSON.parse(localStorage.getItem('printSetup')).logoMarginLeft;
      }
      return 0;
    },
    logoWidth() {
      // if (localStorage.getItem('printSetup')) {
      //   return JSON.parse(localStorage.getItem('printSetup')).logoWidth;
      // }
      return 520;
    },
    provider() {
      const invoiceProvider =
        this.print.provider && typeof this.print.provider === 'object'
          ? this.print.provider._id
          : this.print.provider;
      const queueProvider = this.print.queue && this.print.queue.provider;
      const providerId = invoiceProvider || queueProvider;
      if (providerId) {
        const printProvider = this.providers.find((p) => p._id === providerId);
        if (printProvider) return printProvider;
        return {};
      }
      return {};
    },
    paymentTime() {
      if (Array.isArray(this.print.payments) && this.print.payments.length) {
        const firstPayment = this.print.payments.find((p) => !p.voided && p.date);
        if (firstPayment) {
          return this.formatVDDate(firstPayment.date, { sourceFormat: 'X', lang: this.$i18n.locale, format: 'DD MMM YYYY hh:mm A' });
        }
      }

      return '-';
    },
    patientPayments() {
      const payments = [];
      if (Array.isArray(this.print.payments) && this.print.payments.length) {
        // Loop through the payment records
        this.print.payments
          .filter((p) => !p.voided)
          .forEach((p) => {
            if (Array.isArray(p.payments) && p.payments.length) {
              this.processFees = +this.processFees + +p.totalProcessFees;
              // Loop through the patient payments records
              p.payments.forEach((pp) => {
                let l = pp.label;
                if (pp.defaultPayment) {
                  l = this.trans(`paymentMode.${pp.mode}`);
                  if (pp.mode === 'offset') {
                    l = pp.label.replace(
                      'Offset',
                      this.trans('paymentMode.offset')
                    );
                  }
                  pp.labelTrans = l;
                } else {
                  pp.labelTrans = l;
                }
                const patientPayment = {
                  paymentId: pp._id,
                  paymentRef: p.paymentRef,
                  label: pp.labelTrans,
                  amount: pp.amount,
                };
                payments.push({ ...patientPayment });
              });
            }
          });
      }
      return payments;
    },
    creditPayments() {
      const creditPyments = [];
      if (Array.isArray(this.print.credits) && this.print.credits.length > 0) {
        this.print.credits.filter((i) => {
          const creditPay = {
            mode: i.mode,
            amount: i.creditTotal,
            paymentType: i.paymentType,
            paymentId: i._id,
          };
          creditPyments.push({ ...creditPay });
        });
      }
      return creditPyments;
    },
    corpPayables() {
      const payments = [];
      if (Array.isArray(this.print.payments) && this.print.payments.length) {
        // Loop through the payment records
        this.print.payments
          .filter((p) => !p.voided)
          .forEach((p) => {
            if (Array.isArray(p.corpPayments) && p.corpPayments.length) {
              // Loop through the corp payments records
              p.corpPayments.forEach((cp) => {
                const corpPayment = {
                  paymentId: cp._id,
                  paymentRef: p.paymentRef,
                  label: cp.label,
                  amount: cp.amount,
                  mode: cp.mode,
                };
                payments.push({ ...corpPayment });
              });
            }
          });
      }
      const settlePymt = [];
      if (payments.length > 0 && this.print.corpSettlement.length > 0) {
        for (let i = 0; i < payments.length; i++) {
          for (let j = 0; j < this.print.corpSettlement.length; j++) {
            if (this.print.corpSettlement[j].corporate === payments[i].mode) {
              settlePymt.push({ ...payments[i] });
            }
          }
        }
      }
      if (settlePymt.length > 0) {
        for (let i = payments.length - 1; i >= 0; i--) {
          for (let j = 0; j < settlePymt.length; j++) {
            if (
              payments[i] &&
              payments[i].paymentId === settlePymt[j].paymentId
            ) {
              payments.splice(i, 1);
            }
          }
        }
      }
      return payments;
    },
    corpSettled() {
      const settledPayments = [];
      if (
        Array.isArray(this.print.corpSettlement) &&
        this.print.corpSettlement.length > 0
      ) {
        this.print.corpSettlement.filter((f) => {
          if (f.recordedAmount > 0) {
            const corpSettle = {
              label: f.corporateName,
              amount: f.recordedAmount,
            };
            settledPayments.push({ ...corpSettle });
          }
        });
      }
      return settledPayments;
    },
    hasAtLeastOneItemWithDiscount() {
      return this.print.items.some(
        (item) => item.discount && parseFloat(item.discount) > 0
      );
    },
    instructionsBuilderFeatureFlag() {
      return this.$store.state.config.featureFlags.instructionsBuilder;
    },
    isUsePredefinedCategories() {
      return (
        (this.inventoryConfig &&
          this.inventoryConfig.usePredefinedCategories) ||
        false
      );
    },
    unCategorized() {
      const print = this.print.items.reduce((result, a) => {
        const r = result;
        r[a.inventory] = r[a.inventory] || [];
        r[a.inventory].push(a);
        return r;
      }, Object.create(null));

      // add dispense items into the default sorted inventory by type
      const sortedInvType = Object.assign({}, this.sortedInventoryByType);
      const dispensedInvTypes = Object.keys(print);
      for (let i = 0; i < dispensedInvTypes.length; i += 1) {
        sortedInvType[dispensedInvTypes[i]] = print[dispensedInvTypes[i]];
      }

      // remove empty array of inventory type
      const sortedInvTypeKeys = Object.keys(sortedInvType);
      for (let j = 0; j < sortedInvTypeKeys.length; j += 1) {
        if (sortedInvType[sortedInvTypeKeys[j]].length < 1) {
          delete sortedInvType[sortedInvTypeKeys[j]];
        }
      }

      let tempArr = JSON.parse(JSON.stringify(sortedInvType));
      let invoiceCategories = this.invoiceConfig.invoiceCategory;
      let availableCategories = [];
      let orderCat = {};
      invoiceCategories.map((ite) => {
        if (ite.combined) {
          availableCategories.push(ite.category);
          orderCat[ite.category] = 1;
        }
      });

      Object.keys(tempArr).map((ite) => {
        if (tempArr[ite].length > 0) {
          let itemListTemp = [];
          let itemListHash = {};
          tempArr[ite].map((itemList) => {
            if (
              itemList.category &&
              availableCategories.includes(itemList.category)
            ) {
              if (itemListHash[itemList.category] == undefined) {
                itemListHash[itemList.category] = [];
                itemListHash[itemList.category].push(itemList);
              } else {
                itemListHash[itemList.category].push(itemList);
              }
            } else {
              if (itemListHash[itemList.chineseName] == undefined) {
                itemListHash[itemList.chineseName] = [];
                itemListHash[itemList.chineseName].push(itemList);
              } else {
                itemListHash[itemList.chineseName].push(itemList);
              }
            }
          });

          tempArr[ite] = itemListHash;
        }
      });

      Object.keys(tempArr).map((ite) => {
        let unsorted = {};
        Object.keys(orderCat).map((it) => {
          if (tempArr[ite][it] != undefined) {
            unsorted[it] = tempArr[ite][it];
          }
        });
        Object.keys(tempArr[ite]).map((it) => {
          if (!Object.keys(orderCat).includes(it)) {
            unsorted[it] = tempArr[ite][it];
          }
        });
        tempArr[ite] = unsorted;
      });
      return tempArr;
    },
    rollUpCategorized() {
      // convert data to object with category as key
      // example: { M1: [{...}, {...}], M2: [{...}, {...}] }
      let invoiceCategories = this.invoiceConfig.invoiceCategory;

      let rolledUpData = {};
      let availableCategories = [];
      invoiceCategories.map((ite) => {
        if (ite.combined) {
          rolledUpData[ite.category] = [];
          availableCategories.push(ite.category);
        }
      });

      this.print.items.map((a) => {
        if (availableCategories.includes(a.category)) {
          rolledUpData[a.category].push(a);
        } else {
          if (rolledUpData[a.name] == undefined) {
            rolledUpData[a.name] = [];
            rolledUpData[a.name].push(a);
          }
        }
      });

      let rolledUpDataSum = JSON.parse(JSON.stringify(rolledUpData));

      Object.keys(rolledUpDataSum).map((ite) => {
        rolledUpDataSum[ite] = {
          qty: rolledUpDataSum[ite].reduce(
            (total, a) => Number(total + a.qty) || 0,
            0
          ),
          price: rolledUpDataSum[ite].reduce(
            (total, a) => Number(total + a.price) || 0,
            0
          ),
          tax: rolledUpDataSum[ite].reduce(
            (total, a) => Number(total + a.tax) || 0,
            0
          ),
          afterTaxPrice: rolledUpDataSum[ite].reduce(
            (total, a) => Number(total + a.afterTaxPrice) || 0,
            0
          ),
        };
      });

      return rolledUpDataSum;
    },
    itemNameClass() {
      if (this.isUsePredefinedCategories) {
        return 'col-6';
      }

      return this.printConfig.lineItemsDesc ? 'col-2' : 'col-6';
    },
    totalPaidAmount() {
      const payments = [];
      if (Array.isArray(this.print.payments) && this.print.payments.length) {
        // Loop through the payment records
        this.print.payments
          .filter((p) => !p.voided)
          .forEach((p) => {
            if (Array.isArray(p.payments) && p.payments.length) {
              this.processFees = +this.processFees + +p.totalProcessFees;
              // Loop through the patient payments records
              p.payments.forEach((pp) => {
                let l = pp.label;
                if (pp.defaultPayment) {
                  l = this.trans(`paymentMode.${pp.mode}`);
                  if (pp.mode === 'offset') {
                    l = pp.label.replace(
                      'Offset',
                      this.trans('paymentMode.offset')
                    );
                  }
                  pp.labelTrans = l;
                } else {
                  pp.labelTrans = l;
                }
                const patientPayment = {
                  paymentId: pp._id,
                  paymentRef: p.paymentRef,
                  label: pp.labelTrans,
                  amount: pp.amount,
                  change: pp.changeAmount,
                };
                payments.push({ ...patientPayment });
              });
            }
          });
      }
      return payments.reduce((total, ite) => (total += ite.amount), 0);
    },

    totalChange() {
      const payments = [];
      if (Array.isArray(this.print.payments) && this.print.payments.length) {
        // Loop through the payment records
        this.print.payments
          .filter((p) => !p.voided)
          .forEach((p) => {
            if (Array.isArray(p.payments) && p.payments.length) {
              this.processFees = +this.processFees + +p.totalProcessFees;
              // Loop through the patient payments records
              p.payments.forEach((pp) => {
                let l = pp.label;
                if (pp.defaultPayment) {
                  l = this.trans(`paymentMode.${pp.mode}`);
                  if (pp.mode === 'offset') {
                    l = pp.label.replace(
                      'Offset',
                      this.trans('paymentMode.offset')
                    );
                  }
                  pp.labelTrans = l;
                } else {
                  pp.labelTrans = l;
                }
                const patientPayment = {
                  paymentId: pp._id,
                  paymentRef: p.paymentRef,
                  label: pp.labelTrans,
                  amount: pp.amount,
                  change: pp.changeAmount,
                };
                payments.push({ ...patientPayment });
              });
            }
          });
      }
      return payments.reduce((total, ite) => (total += ite.change), 0);
    },
    total() {
      let total = currency(this.print.total + this.processFees).value;
      if (this.print.virtualCurrencyRedemptions && this.print.virtualCurrencyRedemptions.length > 0) {
        total = currency(total + (this.print.totalVirtualCurrencyRedeemed || 0)).value;
      }
      return total;
    },
    beforeTax() {
      let beforeTax = currency(this.total - this.print.totalTax).value;
      const rounding = !!this.print.roundingAdjustment ? Math.abs(this.print.roundingAdjustment) : 0;
      if (rounding > 0) {
        beforeTax = currency(beforeTax + rounding).value;
      }
      return beforeTax;
    },
    shouldShowMembershipPtBalance() {
      return this.print.totalRedeemablePoints !== null && this.print.totalRedeemablePoints !== undefined;
    },
  },
  async mounted() {
    if (
      !this.preview &&
      !localStorage.getItem('sendEmail') &&
      !localStorage.getItem('sendSMS')
    ) {
      setTimeout(() => {
        window.print();
        this.$emit('print');
      }, 2000);
    }
    await this.sendEmailSMS();
  },
};
</script>

<style scoped src="../../assets/print.css"></style>
<style scoped>
.previewPrint {
  background-color: white;
  font-size: 0.1em !important;
  padding: 20px;
  padding-left: 35px;
  min-height: 60em;
  margin-bottom: 0px !important;
  color: #000000 !important;
}
.previewPrint .address-font {
  font-size: 0.1rem !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.clinic-info {
  font-size: 0.65em !important;
  padding-left: 25% !important;
  margin-top: 2.3rem !important;
}
</style>
